export default __webpack_public_path__ + "static/media/icon_avatar.09b54cda.svg";